import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext.jsx';
import Loading from '../components/Loading.jsx';

const ProtectedRoute = () => {
  const { loading, user, profile, organization } = useAuthContext();
  const url = new URL(window.location.href);
  const location = useLocation();
  const pathname = location.pathname;

  if (loading) {
    return <Loading />;
  } else if (
    user &&
    profile &&
    profile.requires_password_set &&
    pathname !== '/set-password'
  ) {
    //Force user to set password if they haven't done so
    return <Navigate to='/set-password' replace />;
  } else if (!user && pathname === '/set-password') {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const error = hashParams.get('error');
    const errorCode = hashParams.get('error_code');

    //It appears when these hashes come through, supabase force logs you out by clearing the session
    if (error === 'access_denied' && errorCode === 'otp_expired') {
      return <Navigate to='/request-link' replace />;
    } else {
      return <Navigate to='/request-link' replace />;
    }
  } else if (!user) {
    // Preserve the full URL as returnTo when redirecting to signin
    const fullPath = `${pathname}${location.search}`;
    return <Navigate to={`/signin?returnTo=${encodeURIComponent(fullPath)}`} replace />;
  } else if (!organization) {
    return <Loading />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
